function soundUrl(name) {
  if (CONFIG.urls.sound) {
    return CONFIG.urls.sound(name)
  }
  try {
    return require(`../assets/sounds/${name}.mp3`)
  } catch (e) {
    return `./assets/sounds/${name}.mp3`
  }
}

export const isIE = /MSIE|Trident/.test(navigator.userAgent)

export const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

export function iPhoneUnlockSound() {
  const events = ['touchstart', 'touchend', 'mousedown', 'keydown']
  events.forEach(e => document.body.addEventListener(e, unlock))

  function unlock() {
    try {
      const context = new (window.AudioContext || window.webkitAudioContext)()
      if (context) {
        context.resume().then(clean)
      }
      // eslint-disable-next-line no-empty
    } catch (e) {} //no need to log it
  }
  function clean() {
    events.forEach(e => document.body.removeEventListener(e, unlock))
  }
}

export function playSound(name, options = {}, cb = () => {}) {
  const sound = Object.assign(new Audio(soundUrl(name), options))

  const soundPlayed = sound.play()

  if (soundPlayed) {
    soundPlayed.catch(error => {
      console.warn(error, 'Sound not played due to browser restrictions')
      cb()
    })
  } else {
    cb()
  }

  return sound
}

export function simpleHash(str) {
  let hash = 0
  let chr

  if (str.length === 0) {
    return hash
  }
  for (let i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i)
    hash  = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

const TEMP_LOWER = 1
const TEMP_UPPER = 1000000

export function generateNotSentId() {
  const random_in_range = Math.floor(Math.random() * (TEMP_UPPER - TEMP_LOWER)) + TEMP_LOWER
  return random_in_range * -1 //temp numbers should be negative and smaller than -1
}

export function isNotSentId(id) {
  return id > (TEMP_UPPER * -1) && id < (TEMP_LOWER * -1)
}


export const getUpgradeSourceTypeFromUrl = url => {
  if (!url) {
    return null
  }
  try {
    const parsed = new URL(url, window.location.origin)
    return parsed.searchParams.get('upgradeSourceType')
  } catch (e) {
    console.error('No Search Params for upgradeSourceType in widget.', e)
    return null
  }
}


